// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__h3mRI","footer":"ModalInfo_footer__32HgO"};